import { default as VuxAliveTab, aliveTab } from 'ivux-alive-tab/src/index'

export default function(Vue, options = {}) {
	var { router, store, config } = options

	// install ivux-resource
	VuxAliveTab(Vue, options)

	// logout时，清空清空历史栈
	store.subscribe((mutation, state) => {
		if (mutation.type == "clearUser") {
			aliveTab.clear()
		}
	})
}